import React, { createContext, useContext, useState } from 'react'

const EMPTY_STATE = { isOpen: false, Dialog: <></> }

const DialogContext = createContext(EMPTY_STATE)

export function DialogProvider({ children }) {
  const [state, setState] = useState(EMPTY_STATE)

  const openDialog = Dialog => setState({ isOpen: true, Dialog })
  const closeDialog = () => setState(EMPTY_STATE)

  const { isOpen, Dialog } = state

  const value = { isOpen, Dialog, openDialog, closeDialog }

  return (
    <DialogContext.Provider value={value}>
      {isOpen && (
        <>
          <div className='spectrum-Underlay is-open' />
          {Dialog || <></>}
        </>
      )}
      {children}
    </DialogContext.Provider>
  )
}

export function useDialog() {
  const { isOpen, openDialog, closeDialog } = useContext(DialogContext)

  return { isOpen, openDialog, closeDialog }
}
